// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CqkV","col":"styles_col__4lqRp"};